'use client';
import React from 'react';

const brands = [
  'TikTok Shop', 'Sephora', 'Nike', 'SHEIN', 'Amazon', 'Ulta Beauty', 'Gymshark', 'ColourPop',
  'TikTok Shop', 'Sephora', 'Nike', 'SHEIN', 'Amazon', 'Ulta Beauty', 'Gymshark', 'ColourPop',
];

export default function BrandLogosSection() {
  return (
    <section className="py-16 bg-white relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 mb-8">
        <p className="text-center text-[18px] font-medium text-dark/60">
          Trusted by the world&apos;s most innovative brands &amp; sellers
        </p>
      </div>

      {/* Scrolling logos */}
      <div className="relative overflow-hidden">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />

        <div className="flex gap-0 w-max animate-slide-left">
          {brands.map((brand, i) => (
            <div key={i} className="flex items-center">
              <div className="flex items-center gap-3 px-8 py-3">
                <BrandLogo name={brand} index={i} />
              </div>
              <div className="w-px h-8 bg-dark/10" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function BrandLogo({ name, index }: { name: string; index: number }) {
  const colors = ['#9886FE', '#C9FF85', '#7CE1FF', '#FFD86F', '#2BD886', '#D886FE', '#FEEF79', '#120A0B'];
  const color = colors[index % colors.length];
  return (
    <div className="flex items-center gap-2 opacity-60 hover:opacity-100 transition-opacity duration-200">
      <div
        className="w-6 h-6 rounded-md flex-shrink-0"
        style={{ backgroundColor: color }}
      />
      <span className="text-[15px] font-semibold text-dark whitespace-nowrap">{name}</span>
    </div>
  );
}
